export const initSwipers = (els, init, elIsSwiper = false) => {
  els.forEach((el) => {
    if (elIsSwiper) {
      init(el);
      return;
    }
    const swipeEls = el.querySelectorAll('[data-swiper]');
    swipeEls.forEach((swiperEl) => {
      init(swiperEl);
    });
  });
};
